/**
 * AppIcon — logo Eunerd dentro de quadrado colorido (estilo iOS).
 * - Backoffice: fundo verde escuro + marca branca
 * - App (cliente/técnico): fundo branco + marca padrão (azul/cinza)
 */
import type { ComponentProps } from "react";

import { EunerdMark } from "@/components/eunerd-mark";
import { cn } from "@/lib/utils";

interface AppIconProps extends ComponentProps<"div"> {
  variant?: "backoffice" | "app";
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "h-7 w-7 p-1",
  md: "h-9 w-9 p-1.5",
  lg: "h-12 w-12 p-2",
};

export function AppIcon({
  variant = "backoffice",
  size = "md",
  className,
  ...props
}: AppIconProps) {
  const isBack = variant === "backoffice";
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-xl shrink-0",
        sizeClasses[size],
        isBack
          ? "bg-emerald-900 text-white shadow-[0_1px_2px_rgba(15,23,42,0.08),0_8px_20px_-6px_rgba(6,78,59,0.45)]"
          : "bg-white border border-slate-200/80 shadow-[0_1px_2px_rgba(15,23,42,0.06),0_4px_12px_-4px_rgba(15,23,42,0.10)]",
        className,
      )}
      {...props}
    >
      <EunerdMark
        className="h-full w-auto"
        mono={isBack ? "#ffffff" : undefined}
      />
    </div>
  );
}
